// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const savedViewQuerySchema = z.record(z.unknown());

export const savedViewSchema = z.object({
  id: idSchema,
  url: urlSchema,
  name: z.string(),
  query: savedViewQuerySchema,
  shared: z.boolean(),
  organization: urlSchema,
  queuesFilter: z.array(urlSchema),
  createdBy: urlSchema,
  createdAt: z.string(),
  modifiedBy: urlSchema.nullable(),
  modifiedAt: z.string().nullable(),
  isEditable: z.boolean(),
});
